import { render, staticRenderFns } from "./CuratorsGrid.vue?vue&type=template&id=770d9de9"
import script from "./CuratorsGrid.vue?vue&type=script&lang=js"
export * from "./CuratorsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports